import React, {useEffect} from 'react';
import {Tabs, Tab} from '@mui/material';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import {setMenuTab} from '../../store/actions/menu';
import {useTranslation} from 'react-i18next';

//Custom Tabs for the NavMenu
const CustomTabs = ({routes, history, location, idxTab, menuTab}) => {
    const {t} = useTranslation();

    useEffect(() => {
        menuTab(routes)
    }, [location, menuTab, routes]);
    const handleClick = (registerTab = false, route) => (event, newValue) => {
        if (registerTab) {
            // setMenuTab(routes, newValue)
            const menu = route === routes[routes.length - 1] ? 'login' : route
            const anchor = (event.target.ownerDocument || document).querySelector(`#${menu}-menu-id`);
            if (anchor) {
                anchor.scrollIntoView({behavior: 'smooth', block: 'center'});
            }
        } else {
            history.push(route.path);
        }
    }
    const handleChange = (event, newValue) => {
        !routes[0].path && (menuTab(routes, newValue))
    };

    return (
        <Tabs
            value={idxTab >= 0 ? idxTab : false}
            onChange={handleChange}
            variant={"scrollable"}
            sx={{
                '& .MuiTab-root': {
                    fontFamily: "'Montserrat', sans-serif",
                    fontWeight: 500,
                    fontSize: '0.9rem',
                    color: '#49454F',
                    textTransform: 'none',
                    minHeight: '48px',
                    padding: '0 1rem',
                    transition: 'color 0.2s ease',
                    '&:hover': {
                        color: '#6750A4',
                        backgroundColor: 'rgba(103, 80, 164, 0.04)'
                    },
                    '&.Mui-selected': {
                        color: '#6750A4',
                        fontWeight: 600
                    }
                },
                '& .MuiTabs-indicator': {
                    backgroundColor: '#6750A4',
                    height: '3px',
                    borderRadius: '3px 3px 0 0'
                }
            }}
        >
            {
                routes.map((route, index) => (
                    <Tab key={index}
                         label={route.title ? t(route.title) : t(route)}
                         onClick={handleClick(route.title === undefined, route)}/>
                ))
            }
        </Tabs>
    );
}
const mapStateToProps = (state) => ({idxTab: state.menu.type})
const mapDispatchToProps = dispatch => ({menuTab: (routes, index) => dispatch(setMenuTab(routes, index))})
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CustomTabs));
